/**
 * An array of route objects used for defining application routes.
 * Each object contains a `key` and a `route` property.
 *
 * @type {Array<{ key: string; route: string }>}
 */
export const ROUTES: { key: string; route: string }[] = [
  /** Start Small Pack Routes **/
  {
    key: 'sm-pck-file-imports',
    route: '/small-pack/file-imports'
  },
  {
    key: 'sm-pck-validations',
    route: '/small-pack/validations'
  },
  {
    key: 'sm-pck-maint',
    route: '/small-pack/maintenance'
  },
  {
    key: 'sm-pck-build-invoice',
    route: '/small-pack/build-invoice'
  },
  {
    key: 'sm-pck-metrics',
    route: '/small-pack/metrics'
  },
  {
    key: 'sm-pck-file-processing',
    route: '/small-pack/file-processing'
  },
  {
    key: 'sm-pck-manual-invoice-search',
    route: '/small-pack/manual-invoice-search'
  },
  /** End Small Pack Routes **/
  /** Start Hairball Routes **/
  {
    key: 'Customer_Onboarding_Dashboard',
    route: '/hairball/onboarding-dashboard'
  },
  {
    key: 'Auto_Audit_Validation_Dashboard',
    route: '/hairball/auditing-workflow/audit-validation-dashboard'
  },
  {
    key: 'brokerage-validation-dashboard',
    route: '/hairball/auditing-workflow/brokerage-validation-dashboard'
  },
  {
    key: 'Exception_Override_Requests',
    route: '/hairball/auditing-workflow/audit-validation-override-requests'
  },
  {
    key: 'man-exp',
    route: '/hairball/auditing-workflow/manual-expense-code'
  },
  {
    key: 'man-dir',
    route: '/hairball/auditing-workflow/manual-directions'
  },
  {
    key: 'Edit_Grid',
    route: '/hairball/auditing-workflow/edit-grid'
  },
  {
    key: 'Cust_Review',
    route: '/hairball/billing/customer-review'
  },
  {
    key: 're-bill',
    route: '/hairball/settlement/re-bill'
  },
  {
    key: 'man-audit',
    route: '/hairball/settlement/internal-review'
  },
  {
    key: 'tms_charge_code_mapping',
    route: '/hairball/auditing-workflow/tms-charge-code-mapping'
  },
  {
    key: 'mass_assignment',
    route: '/hairball/auditing-workflow/mass-assignment'
  },
  {
    key: 'analytics_dashboard',
    route: '/hairball/auditing-workflow/analytics-dashboard'
  },
  /** End Hairball Routes **/
  /** Start Invoicing Routes **/
  {
    key: 'Invoice_Batch_exception',
    route: '/invoicing/invoice-status-dashboard'
  },
  {
    key: 'invoice_shipment_status',
    route: '/invoicing/shipment-status'
  },
  {
    key: 'invoice-uninvoiced-status',
    route: '/invoicing/uninvoiced-status'
  },
  {
    key: 'invoice_req_docs',
    route: '/invoicing/required-documents'
  },
  {
    key: 'invoice_carrier_payables',
    route: '/invoicing/carrier-payables'
  },
  /** End Invoicing Routes **/
  /** Start LynnCo Admin Routes **/
  {
    key: 'map-data-tms-extract',
    route: '/lynnco-admin/tms-extract'
  },
  {
    key: 'mgt_data',
    route: '/lynnco-admin/management-data'
  },
  {
    key: 'process-config',
    route: '/lynnco-admin/process-config'
  },
  {
    key: 'ReportScheduler',
    route: '/lynnco-admin/report-scheduler'
  },
  {
    key: 'background-jobs',
    route: '/lynnco-admin/background-jobs'
  },
  {
    key: 'lynnco-bi-maintenance',
    route: '/lynnco-admin/lynnco-bi-maintenance'
  },
  /** End LynnCo Admin Routes **/
  /** Start General Routes **/
  {
    key: 'sales-accrual',
    route: '/accounting/sales-accrual'
  },
  {
    key: 'ISRCH',
    route: '/imperia-search'
  },
  {
    key: 'operation-warehouse-edi',
    route: '/operations/warehouse-edi'
  },
  {
    key: 'Customer_Config_Maint',
    route: '/customer-maintenance'
  },
  {
    key: 'Carrier_Config_Maint',
    route: '/carrier-maintenance'
  },
  {
    key: 'stage-carrier-import',
    route: '/carrier-maintenance/staged-carrier-import'
  },
  {
    key: 'Shipment_Master',
    route: '/shipment-master/load-list'
  },
  {
    key: 'staged-carrier-documents',
    route: '/carrier-maintenance/staged-carrier-documents'
  },
  /** End General Routes **/
  /** Start Monitoring Routes **/
  {
    key: 'monitor-shipments',
    route: '/monitoring/shipments'
  },
  {
    key: 'tms-file-processing',
    route: '/monitoring/tms-file-processing'
  },
  /** End Monitoring Routes **/
  /** Start Imperia Admin Routes **/
  {
    key: 'imperia-admin-notification',
    route: '/imperia-admin/manual-internal-notification'
  },
  /** End Imperia Admin Routes **/
  /** StartPricing Engine Routes **/
  {
    key: 'pricing-engine',
    route: '/pricing-engine'
  },
  {
    key: 'rate-lookup',
    route: '/pricing-engine/rate-lookup'
  },
  {
    key: 'batch-rate',
    route: '/pricing-engine/batch-rate'
  },
  {
    key: 'usage-report',
    route: '/pricing-engine/usage-report'
  }
  /** End Pricing Engine Routes **/
];
